import React, { lazy } from 'react';
import {
	primaryChemistMenu,
	layoutPages,
	chemistMenuGroupOverview,
	chemistMenuGroupManagement,
	chemistMenuGroupLogistics,
} from '../menu';
import Login from '../pages/presentation/auth/Login';
import PrivateRoute from '../PrivateRoute/PrivateRoute';

const CHEMIST_CONTENT_ROUTES = {
	DASHBOARD: {
		DASHBOARD: lazy(() => import('../pages/chemist-pages/dashboard/DashboardView')),
		// TEST_PAGE:lazy(()=>import('../pages/chemist-pages/Test/Test'))
	},
	DATA: {
		TARGET_AND_ACHIEVEMENT: lazy(() =>
			import('../pages/chemist-pages/data/TargetAndAchievement'),
		),
		DEPOT_AND_REVENUE: lazy(() => import('../pages/chemist-pages/data/DepotRevenueCollection')),
		SALES: lazy(() => import('../pages/chemist-pages/data/SalesReport')),
		PRESCRIPTION: lazy(() => import('../pages/chemist-pages/data/PrescriptionReport')),
		DOCTOR_VISIT: lazy(() => import('../pages/chemist-pages/data/DoctorVisit')),
		ENTITY: lazy(() => import('../pages/chemist-pages/data/Entity')),
		ENTITYGIFT: lazy(() => import('../pages/chemist-pages/data/EntityGift')),
		REPORTING_DATA: lazy(() => import('../pages/chemist-pages/data/ReportingData')),
		LIVE_TV: lazy(() => import('../pages/full/LiveData')),
	},
	REPORTING: {
		PRODUCT_WISE_PRESCRIPTION: lazy(() =>
			import('../pages/chemist-pages/reporting/ProductWisePrescription'),
		),
		PRODUCT_AND_DEPOT: lazy(() =>
			import('../pages/chemist-pages/reporting/ProductDepotWisePrescriptionReport'),
		),
		TOP_PRODUCT: lazy(() => import('../pages/chemist-pages/reporting/TopFiveProducts')),
		TOP_PRESCRIPTION: lazy(() => import('../pages/chemist-pages/reporting/TopEmployeeByPres')),
		TOP_VISIT: lazy(() => import('../pages/chemist-pages/reporting/TopEmployeeByDocVisit')),
		OVERALL_VISIT_REPORT: lazy(() =>
			import('../pages/chemist-pages/reporting/OverallVisitReport'),
		),
		OVERALL_MRD_REPORT: lazy(() => import('../pages/chemist-pages/reporting/MRDReport')),
		ATTENDENCE_REPORT: lazy(() => import('../pages/chemist-pages/reporting/AttendenceReport')),
		TEAM_LEADER_OVERVIEW: lazy(() =>
			import('../pages/chemist-pages/reporting/TeamLeaderOverview'),
		),
	},
	TARGETS: {
		TARGETSVIEW: lazy(() => import('../pages/chemist-pages/targets/Target')),
		PRODUCT_TARGET: lazy(() => import('../pages/chemist-pages/targets/ProductTarget')),
		ACHIEVED_TARGET: lazy(() => import('../pages/chemist-pages/targets/AchievedTarget')),
		ACHIEVED_PRODUCT_TARGET: lazy(() =>
			import('../pages/chemist-pages/targets/AchievedProductTarget'),
		),
	},
	DONATION: {
		DONATION_LIST: lazy(() => import('../pages/chemist-pages/donation/Donation')),
	},
	TOUR: {
		TOUR_PLAN: lazy(() => import('../pages/chemist-pages/tour/TourPlan')),
	},
	REQUISITIONS: {
		REQUISITIONS_LIST: lazy(() => import('../pages/chemist-pages/requisitions/Requisitions')),
	},
	SETTINGS: {
		TERRITORY: lazy(() => import('../pages/chemist-pages/settings/Territory')),
		PHARMACY_LIST: lazy(() => import('../pages/chemist-pages/settings/PharmacyList')),
		GIFT: lazy(() => import('../pages/chemist-pages/settings/Gift')),
		MANAGE_PRODUCT: lazy(() => import('../pages/chemist-pages/settings/ManageProduct')),
		WAREHOUSE_LIST: lazy(() => import('../pages/chemist-pages/settings/WareHouseList')),
		USERS: lazy(() => import('../pages/chemist-pages/settings/UserManagement')),
		PRODUCTS_LIST: lazy(() => import('../pages/chemist-pages/settings/ProductsList')),
		DOCTORS_LIST: lazy(() => import('../pages/chemist-pages/settings/DoctorsManagement')),
		NOTICE_BOARD: lazy(() => import('../pages/chemist-pages/settings/NoticeBoard')),
		PRODUCT_GROUP: lazy(() => import('../pages/chemist-pages/settings/ProductGrouping')),
	},
};
const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};
const presentation = [
	/*
	 * DASHBOARD
	 */
	{
		path: chemistMenuGroupOverview.dashboard.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.DASHBOARD.DASHBOARD />{' '}
			</PrivateRoute>
		),
		exact: true,
	},
	// {
	// 	path: chemistMenuGroupOverview.test.path,
	// 	element: (
	// 		<PrivateRoute>
	// 			<CHEMIST_CONTENT_ROUTES.DASHBOARD.TEST_PAGE />
	// 		</PrivateRoute>
	// 	),
	// 	exact: true,
	// },
	/*
	 * DATA
	 */
	{
		path: chemistMenuGroupOverview.data.subMenu.target_and_achievement.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.DATA.TARGET_AND_ACHIEVEMENT />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.data.subMenu.depot_Revenue_collection.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.DATA.DEPOT_AND_REVENUE />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.data.subMenu.prescriptions.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.DATA.PRESCRIPTION />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: layoutPages.live_tv.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.DATA.LIVE_TV />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.data.subMenu.doctor_visit.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.DATA.DOCTOR_VISIT />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.data.subMenu.entity.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.DATA.ENTITY />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.data.subMenu.donationRecord.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.DATA.ENTITYGIFT />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.data.subMenu.reportingData.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.DATA.REPORTING_DATA />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.data.subMenu.sales.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.DATA.SALES />
			</PrivateRoute>
		),
		exact: true,
	},
	/*
	 * REPORTING
	 */
	{
		path: chemistMenuGroupOverview.reporting.subMenu.product_wise_prescription.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.REPORTING.PRODUCT_WISE_PRESCRIPTION />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.reporting.subMenu.product_and_depot_wise_prescription_report
			.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.REPORTING.PRODUCT_AND_DEPOT />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.reporting.subMenu.top_visit.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.REPORTING.TOP_VISIT />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.reporting.subMenu.top_prescription.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.REPORTING.TOP_PRESCRIPTION />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.reporting.subMenu.top_products.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.REPORTING.TOP_PRODUCT />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.reporting.subMenu.overall_visit_report.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.REPORTING.OVERALL_VISIT_REPORT />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.reporting.subMenu.attendence_report.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.REPORTING.ATTENDENCE_REPORT />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.reporting.subMenu.overall_mrd_report.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.REPORTING.OVERALL_MRD_REPORT />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupOverview.reporting.subMenu.team_leader_overview.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.REPORTING.TEAM_LEADER_OVERVIEW />
			</PrivateRoute>
		),
		exact: true,
	},
	/*
	 * TARGETS
	 */
	{
		path: chemistMenuGroupManagement.targets.subMenu.target.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.TARGETS.TARGETSVIEW />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupManagement.targets.subMenu.achieved_target.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.TARGETS.ACHIEVED_TARGET />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupManagement.targets.subMenu.product_target.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.TARGETS.PRODUCT_TARGET />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: chemistMenuGroupManagement.targets.subMenu.achieved_product_target.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.TARGETS.ACHIEVED_PRODUCT_TARGET />
			</PrivateRoute>
		),
		exact: true,
	},
	/*
	 * DONATION
	 */
	{
		path: chemistMenuGroupManagement.donation_module.subMenu.donation.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.DONATION.DONATION_LIST />
			</PrivateRoute>
		),
		exact: true,
	},
	/*
	 * TOUR PLAN
	 */
	{
		path: chemistMenuGroupManagement.tour_plan.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.TOUR.TOUR_PLAN />
			</PrivateRoute>
		),
		exact: true,
	},
	/*
	 * REQUISITION
	 */
	{
		path: chemistMenuGroupLogistics.requisitions.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.REQUISITIONS.REQUISITIONS_LIST />
			</PrivateRoute>
		),
		exact: true,
	},
	/*
	 * SETTINGS
	 */
	{
		path: primaryChemistMenu.settings.subMenu.territory.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.SETTINGS.TERRITORY />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: primaryChemistMenu.settings.subMenu.pharmacies.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.SETTINGS.PHARMACY_LIST />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: primaryChemistMenu.settings.subMenu.donationCategory.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.SETTINGS.GIFT />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: primaryChemistMenu.settings.subMenu.manageProducts.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.SETTINGS.MANAGE_PRODUCT />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: primaryChemistMenu.settings.subMenu.warehouses.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.SETTINGS.WAREHOUSE_LIST />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		index: true,
		path: primaryChemistMenu.settings.subMenu.noticeBoard.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.SETTINGS.NOTICE_BOARD />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: primaryChemistMenu.settings.subMenu.users.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.SETTINGS.USERS />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		index: true,
		path: primaryChemistMenu.settings.subMenu.product.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.SETTINGS.PRODUCTS_LIST />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		index: true,
		path: primaryChemistMenu.settings.subMenu.product_grouping.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.SETTINGS.PRODUCT_GROUP />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		index: true,
		path: primaryChemistMenu.settings.subMenu.doctors.path,
		element: (
			<PrivateRoute>
				<CHEMIST_CONTENT_ROUTES.SETTINGS.DOCTORS_LIST />
			</PrivateRoute>
		),
		exact: true,
	},
	{
		path: layoutPages.page404.path,
		element: <AUTH.PAGE_404 />,
		exact: true,
	},
	{
		path: layoutPages.login.path,
		element: <Login />,
		exact: true,
	},
	{
		path: layoutPages.signUp.path,
		element: <Login isSignUp />,
		exact: true,
	},
];
const contents = [...presentation];

export default contents;
